(() => {
  const RETURN_KEY = 'pitb_back_return';
  const here = () => window.location.href.split('#')[0];

  const isCartPath = (value) => {
    try {
      const path = new URL(value, window.location.origin).pathname.replace(/\/+$/, '') || '/';
      return path === '/cart' || path.endsWith('/cart');
    } catch (err) {
      return false;
    }
  };

  const usableSameOriginUrl = (value) => {
    try {
      if (!value) return '';
      const url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin) return '';
      if (url.href.split('#')[0] === here()) return '';
      if (isCartPath(url.href)) return '';
      return url.href;
    } catch (err) {
      return '';
    }
  };

  const sameOriginPrevious = () => usableSameOriginUrl(document.referrer);

  const storedReturn = () => {
    try {
      return usableSameOriginUrl(sessionStorage.getItem(RETURN_KEY) || '');
    } catch (err) {
      return '';
    }
  };

  const rememberCurrentPage = () => {
    if (isCartPath(window.location.href)) return;
    try {
      sessionStorage.setItem(RETURN_KEY, window.location.href);
    } catch (err) {
      /* private mode / blocked storage */
    }
  };

  rememberCurrentPage();

  document.addEventListener(
    'click',
    (event) => {
      const link = event.target && event.target.closest && event.target.closest('a[href]');
      if (!link) return;
      const href = link.getAttribute('href') || '';
      if (!href || href.includes('/checkout')) return;
      if (!isCartPath(href)) return;
      rememberCurrentPage();
    },
    true
  );

  const previousPage = () => sameOriginPrevious() || storedReturn();

  const bind = (back) => {
    if (back.dataset.pitbBackBound === '1') return;
    back.dataset.pitbBackBound = '1';

    const previous = previousPage();
    if (previous) back.setAttribute('href', previous);

    back.addEventListener('click', (event) => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) {
        return;
      }

      // Prefer history.back when referrer proves a same-origin prior page.
      // Otherwise use the stashed return URL (cart often loses referrer).
      const fromReferrer = sameOriginPrevious();
      const fromStore = storedReturn();
      const prev = fromReferrer || fromStore;
      if (!prev) return;

      event.preventDefault();
      if (fromReferrer) {
        window.history.back();
        return;
      }
      window.location.assign(prev);
    });
  };

  document.querySelectorAll('[data-pitb-back]').forEach(bind);
})();
